import { Plan } from '../apiTypes';

export const getPlanLabel = (plan: Pick<Plan, 'stripeName' | 'interval'>) => {
  return `${plan.stripeName}`;
}
